/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import {
  EditingState,
  SortingState,
  IntegratedSorting,
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
  DataTypeProvider,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  TableEditColumn,
  Toolbar,
  SearchPanel,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnVisibility,
  ColumnChooser,
  PagingPanel,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-material-ui';
import { useUsers } from '../../hooks';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Chip,
} from '@material-ui/core';
import useCompany from '../../hooks/useCompany';
import { useLazyQuery, useMutation } from '@apollo/client';
import { getSuggestions } from '../../graphql/query';
import {
  createSuggestion,
  deleteSuggestion,
  updateSuggestion,
} from '../../graphql/mutation';
import { getColumns } from '../constants/columns';
import { errorAlert, errorDeleteAlert, getRowId } from '../common/funcs';
import PageLayout from '../shared/PageLayout';
import { TableComponent } from '../components/TableComponent';
import { createdAtFormatter, userFormatter } from '../common/formater';
import { Command } from '../components/Command';
import SearchTable from '../components/SearchTable';
import PopupEditing from '../components/PopupEditing';
import AlertLocal from '../components/AlertLocal';
import PopupSuggestion from './PopupSuggestion';
import PopupSuggestionView from './PopupSuggestionView';

// Suggestion categories
const suggestionCategories = [
  { value: 'all', name: 'All', nameAr: 'الكل' },
  { value: 'development', name: 'Development', nameAr: 'تطوير' },
  { value: 'improvement', name: 'Improvement', nameAr: 'تحسين' },
  { value: 'complaint', name: 'Complaint', nameAr: 'شكوى' },
  { value: 'other', name: 'Other', nameAr: 'أخرى' },
];

// Status options
const statusOptions = [
  { value: 'all', name: 'All', nameAr: 'الكل' },
  { value: 'new', name: 'New', nameAr: 'جديد' },
  { value: 'reviewing', name: 'Reviewing', nameAr: 'قيد المراجعة' },
  { value: 'approved', name: 'Approved', nameAr: 'مقبول' },
  { value: 'rejected', name: 'Rejected', nameAr: 'مرفوض' },
  { value: 'implemented', name: 'Implemented', nameAr: 'تم التنفيذ' },
];

export default function SuggestionsManagement({
  isRTL,
  words,
  theme,
  menuitem,
}: any) {
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');

  const [item, setItem] = useState(null);
  const [openItem, setOpenItem] = useState(false);

  const { height, width } = useWindowDimensions();
  const { company } = useCompany();
  const { users } = useUsers();
  const col = getColumns({ isRTL, words });

  const columns = [
    col.createdAt,
    { name: 'title', title: isRTL ? 'العنوان' : 'Title' },
    { name: 'category', title: isRTL ? 'التصنيف' : 'Category' },
    { name: 'priority', title: isRTL ? 'الأولوية' : 'Priority' },
    { name: 'status', title: isRTL ? 'الحالة' : 'Status' },
    {
      name: isRTL ? 'employeeNameAr' : 'employeeName',
      title: isRTL ? 'مقدم الاقتراح' : 'Submitted By',
    },
    col.userId,
  ];

  const [tableColumnExtensions]: any = useState([
    { columnName: 'createdAt', width: 150 },
    { columnName: 'title', width: 250 },
    { columnName: 'category', width: 130 },
    { columnName: 'priority', width: 100 },
    { columnName: 'status', width: 130 },
    { columnName: isRTL ? 'employeeNameAr' : 'employeeName', width: 180 },
    { columnName: 'userId', width: 120 },
  ]);

  const [loadSuggestions, suggestionsData]: any = useLazyQuery(getSuggestions, {
    fetchPolicy: 'cache-and-network',
  });

  const refresQuery = {
    refetchQueries: [
      {
        query: getSuggestions,
        variables: {
          category: selectedCategory === 'all' ? undefined : selectedCategory,
          status: selectedStatus === 'all' ? undefined : selectedStatus,
        },
      },
    ],
  };

  const [addSuggestion] = useMutation(createSuggestion, refresQuery);
  const [editSuggestion] = useMutation(updateSuggestion, refresQuery);
  const [removeSuggestion] = useMutation(deleteSuggestion, refresQuery);

  useEffect(() => {
    loadSuggestions({
      variables: {
        category: selectedCategory === 'all' ? undefined : selectedCategory,
        status: selectedStatus === 'all' ? undefined : selectedStatus,
      },
    });
  }, [selectedCategory, selectedStatus]);

  useEffect(() => {
    if (suggestionsData?.loading) {
      setLoading(true);
    }
    if (suggestionsData?.data?.getSuggestions?.data) {
      const data = suggestionsData?.data?.getSuggestions?.data;
      setRows(data);
      setLoading(false);
    }
  }, [suggestionsData]);

  const onCloseItem = () => {
    setOpenItem(false);
    setItem(null);
  };

  const commitChanges = async ({ deleted }: any) => {
    if (deleted) {
      const _id = deleted[0];
      const res = await removeSuggestion({ variables: { _id } });
      if (res?.data?.deleteSuggestion?.ok === false) {
        if (res?.data?.deleteSuggestion?.error?.includes('related')) {
          await errorDeleteAlert(setAlrt, isRTL);
        } else {
          await errorAlert(setAlrt, isRTL);
        }
      }
    }
  };

  const refresh = () => {
    loadSuggestions({
      variables: {
        category: selectedCategory === 'all' ? undefined : selectedCategory,
        status: selectedStatus === 'all' ? undefined : selectedStatus,
      },
    });
  };

  const categoryFormatter = ({ value }: any) => {
    const cat = suggestionCategories.find((c) => c.value === value);
    return <span>{isRTL ? cat?.nameAr : cat?.name}</span>;
  };

  const priorityFormatter = ({ value }: any) => {
    const colors: any = {
      low: '#4caf50',
      medium: '#ff9800',
      high: '#f44336',
      urgent: '#9c27b0',
    };
    const labels: any = {
      low: isRTL ? 'منخفض' : 'Low',
      medium: isRTL ? 'متوسط' : 'Medium',
      high: isRTL ? 'عالي' : 'High',
      urgent: isRTL ? 'عاجل' : 'Urgent',
    };
    return (
      <Chip
        size="small"
        label={labels[value] || value}
        style={{
          backgroundColor: colors[value] || '#9e9e9e',
          color: '#fff',
        }}
      />
    );
  };

  const statusFormatter = ({ value }: any) => {
    const colors: any = {
      new: '#2196f3',
      reviewing: '#ff9800',
      approved: '#4caf50',
      rejected: '#f44336',
      implemented: '#9c27b0',
    };
    const labels: any = {
      new: isRTL ? 'جديد' : 'New',
      reviewing: isRTL ? 'قيد المراجعة' : 'Reviewing',
      approved: isRTL ? 'مقبول' : 'Approved',
      rejected: isRTL ? 'مرفوض' : 'Rejected',
      implemented: isRTL ? 'تم التنفيذ' : 'Implemented',
    };
    return (
      <Chip
        size="small"
        label={labels[value] || value}
        style={{
          backgroundColor: colors[value] || '#9e9e9e',
          color: '#fff',
        }}
      />
    );
  };

  return (
    <PageLayout
      menuitem={menuitem}
      isRTL={isRTL}
      words={words}
      theme={theme}
      refresh={refresh}
      loading={loading}
    >
      <Box
        style={{
          height: height - 50,
          overflow: 'auto',
        }}
      >
        <Box
          display="flex"
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: '10px 25px',
          }}
        >
          <Typography
            style={{
              fontWeight: 'bold',
              fontSize: 20,
            }}
          >
            {isRTL ? 'الاقتراحات والمقترحات' : 'Suggestions & Proposals'}
          </Typography>
          <Box display="flex" style={{ gap: 16 }}>
            <FormControl style={{ minWidth: 150, marginRight: 16 }}>
              <InputLabel>{isRTL ? 'التصنيف' : 'Category'}</InputLabel>
              <Select
                value={selectedCategory}
                onChange={(e: any) => setSelectedCategory(e.target.value)}
              >
                {suggestionCategories.map((cat) => (
                  <MenuItem key={cat.value} value={cat.value}>
                    {isRTL ? cat.nameAr : cat.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl style={{ minWidth: 150 }}>
              <InputLabel>{isRTL ? 'الحالة' : 'Status'}</InputLabel>
              <Select
                value={selectedStatus}
                onChange={(e: any) => setSelectedStatus(e.target.value)}
              >
                {statusOptions.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {isRTL ? opt.nameAr : opt.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>

        <Paper
          elevation={5}
          style={{
            margin: 25,
            marginTop: 10,
            overflow: 'auto',
            width: width - 300,
            borderRadius: 10,
          }}
        >
          <Grid rows={rows} columns={columns} getRowId={getRowId}>
            <SortingState />
            <EditingState onCommitChanges={commitChanges} />
            <SearchState />
            <PagingState defaultCurrentPage={0} defaultPageSize={10} />

            <IntegratedSorting />
            <IntegratedFiltering />
            <IntegratedPaging />

            <DragDropProvider />

            <Table
              messages={{
                noData: isRTL ? 'لا يوجد بيانات' : 'No data',
              }}
              tableComponent={TableComponent}
              rowComponent={(props: any) => (
                <Table.Row {...props} style={{ height: 50 }}></Table.Row>
              )}
              columnExtensions={tableColumnExtensions}
            />

            <TableColumnReordering
              defaultOrder={[
                'createdAt',
                'title',
                'category',
                'priority',
                'status',
                isRTL ? 'employeeNameAr' : 'employeeName',
                'userId',
              ]}
            />
            <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />
            <TableHeaderRow
              showSortingControls
              titleComponent={({ children }) => {
                return (
                  <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                    {children}
                  </Typography>
                );
              }}
            />
            <TableColumnVisibility
              defaultHiddenColumnNames={[]}
              messages={{
                noColumns: isRTL ? 'لا يوجد اعمدة' : 'No columns',
              }}
            />

            <DataTypeProvider
              for={['createdAt']}
              formatterComponent={createdAtFormatter}
            />
            <DataTypeProvider
              for={['category']}
              formatterComponent={categoryFormatter}
            />
            <DataTypeProvider
              for={['priority']}
              formatterComponent={priorityFormatter}
            />
            <DataTypeProvider
              for={['status']}
              formatterComponent={statusFormatter}
            />
            <DataTypeProvider
              for={['userId']}
              formatterComponent={({ value }: any) =>
                userFormatter({ value, users, isRTL })
              }
            />

            <TableEditColumn
              showAddCommand
              showEditCommand
              showDeleteCommand
              commandComponent={Command}
            ></TableEditColumn>

            <Toolbar />
            <ColumnChooser />
            <PagingPanel
              pageSizes={[5, 10, 20, 50, 0]}
              messages={{
                info: isRTL
                  ? ({ from, to, count }: any) => ` من ${from} الى ${to} المجموع ${count}`
                  : undefined,
                rowsPerPage: isRTL ? 'عدد السطور' : undefined,
              }}
            />
            <SearchPanel
              inputComponent={(props: any) => {
                return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
              }}
            />

            <PopupEditing
              theme={theme}
              addAction={addSuggestion}
              editAction={editSuggestion}
              alrt={alrt}
              setAlrt={setAlrt}
            >
              <PopupSuggestion
                isRTL={isRTL}
                words={words}
                theme={theme}
                company={company}
                categories={suggestionCategories.filter((c) => c.value !== 'all')}
              ></PopupSuggestion>
            </PopupEditing>
          </Grid>
        </Paper>
        {item && (
          <PopupSuggestionView
            open={openItem}
            onClose={onCloseItem}
            row={item}
            theme={theme}
            company={company}
            isRTL={isRTL}
            words={words}
          ></PopupSuggestionView>
        )}
        {alrt.show && (
          <AlertLocal
            isRTL={isRTL}
            type={alrt?.type}
            msg={alrt?.msg}
            top
          ></AlertLocal>
        )}
      </Box>
    </PageLayout>
  );
}
